const media_types = {
  pdf: 'application/pdf',
  word:
    '.odt,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
} as const;

export default media_types;
